import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    currentMenuName: 'ai-video-bg-remover',
    notImageBoxTitle: 'ai-video-background-remover-not-resource-title',
    notImageBoxDesc: 'ai-video-background-remover-not-resource-desc',
    autoNotVideoBoxTitle: 'auto-remove-bg-title',
    autoNotVideoBoxDesc: 'auto-remove-bg-desc',
    freeLimitType: 'video-background-remove',
    autoRemoverLimitType: 'auto-video-background-remove',
    historyListType: 18,
    originalImageKey: 'ai/input/video-background-remove/',
    resultImageKey: 'ai/export/video-background-remove/',
    resultCoverKey: 'ai/export/video-background-remove/cover/',
    videoRemoveBgMaskS3key: 'ai/export/video-background-remove/mask/',

    transparentPngUrl:
        environment === LOCAL
            ? `/public/img/transparent.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/transparent.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/videoRemoveBg/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/videoRemoveBg/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/videoRemoveBg/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/videoRemoveBg/video.mp4?v=${FJVersionConfig.staticPathVersion}`,

    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,
    videoThumbnailWorkerPath:
        environment === LOCAL
            ? `/public/lib/work/thumbnail/2.0.18/videoThumbnailWorker.js`
            : `/app/ai-tools/lib/work/thumbnail/2.0.18/videoThumbnailWorker.min.js`,

    nullPointVideoUrl:
        environment === LOCAL
            ? `/public/img/videoRemoveBg/null_point_video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/videoRemoveBg/null_point_video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    backgroundPhotoListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/photoRemoveBg/backgroundList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/photoRemoveBg/backgroundList.json?v=${FJVersionConfig.staticPathVersion}`,
    flexClipBgPhotoThumbnailBaseUrl:
        environment === LOCAL ? `/public/img/photoRemoveBg/thumbnail/` : `/app/ai-tools/img/photoRemoveBg/thumbnail/`,
    flexClipBgPhotoBaseUrl:
        environment === LOCAL ? `/public/img/photoRemoveBg/background/` : `/app/ai-tools/img/photoRemoveBg/background/`,
};
